// extracted by mini-css-extract-plugin
export default {"text":"contactInfo_text__Rq2Iu"};